import React from 'react';
import DsButton from '../../../common/DsButton';
import DsModal from '../../../common/DsModal';
import '../../../../css/admin/events/AutomaticTicketSitePickerModal.css';

export type AutomaticTicketGuide = 'teket' | 'eplus' | 'pia' | 'lawson';

type Props = {
  open: boolean;
  onClose: () => void;
  onSelect: (guide: AutomaticTicketGuide) => void;
  availableGuides?: AutomaticTicketGuide[];
  loading?: boolean;
  loadError?: string;
};

export const AUTOMATIC_TICKET_GUIDES: Array<{
  code: AutomaticTicketGuide;
  name: string;
  description: string;
}> = [
  {
    code: 'teket',
    name: 'Teket',
    description: '団体を選び、イベントIDまたはチケット販売ページURLで連携します。',
  },
  {
    code: 'eplus',
    name: 'イープラス',
    description: '取得済みの同日公演から、連携する公演と券種を選びます。',
  },
  {
    code: 'pia',
    name: 'チケットぴあ',
    description: '販売開始前は連動できません。販売開始後、次回の取得完了後（通常は翌朝。管理者が今すぐ取得した場合は同日）に同日公演から選びます。',
  },
  {
    code: 'lawson',
    name: 'ローチケ',
    description: '販売開始前は連動できません。販売開始後、次回の取得完了後（通常は翌朝。管理者が今すぐ取得した場合は同日）に販売受付ごとの券種を選びます。',
  },
];

type OptionsProps = Pick<Props, 'onSelect' | 'availableGuides' | 'loading' | 'loadError'> & {
  showLead?: boolean;
};

export function AutomaticTicketSitePickerOptions({
  onSelect,
  availableGuides,
  loading = false,
  loadError = '',
  showLead = true,
}: OptionsProps) {
  const visibleGuides = availableGuides == null
    ? AUTOMATIC_TICKET_GUIDES
    : AUTOMATIC_TICKET_GUIDES.filter((guide) => availableGuides.includes(guide.code));
  return (
    <>
      {showLead ? (
        <p className="automatic-ticket-site-picker__lead">
          管理者が利用準備を完了したサイトだけを表示しています。サイトを選ぶと、このイベントとの連動設定へ進みます。
        </p>
      ) : null}
      {loading ? (
        <p className="automatic-ticket-site-picker__state">利用可能なサイトを確認しています…</p>
      ) : loadError ? (
        <p className="automatic-ticket-site-picker__state is-error" role="alert">{loadError}</p>
      ) : visibleGuides.length ? (
        <div className="automatic-ticket-site-picker__options">
          {visibleGuides.map((guide) => (
            <DsButton
              key={guide.code}
              type="button"
              variant="secondary"
              className="automatic-ticket-site-picker__option"
              onClick={() => onSelect(guide.code)}
            >
              <strong>{guide.name}</strong>
              <span>{guide.description}</span>
            </DsButton>
          ))}
        </div>
      ) : (
        <p className="automatic-ticket-site-picker__state">
          現在利用できる自動取得サイトはありません。プレイガイドアカウントを管理する担当者へ確認してください。
        </p>
      )}
    </>
  );
}

export default function AutomaticTicketSitePickerModal({
  open,
  onClose,
  onSelect,
  availableGuides,
  loading = false,
  loadError = '',
}: Props) {
  return (
    <DsModal
      open={open}
      onClose={onClose}
      title="自動取得するサイトを選択"
      ariaLabel="自動取得するサイトを選択"
      size="sm"
      className="automatic-ticket-site-picker"
      overlayClassName="automatic-ticket-site-picker__overlay"
      footer={null}
    >
      <AutomaticTicketSitePickerOptions
        onSelect={onSelect}
        availableGuides={availableGuides}
        loading={loading}
        loadError={loadError}
      />
    </DsModal>
  );
}
